
<template>

<div id="content" class="content" style="margin-left:0px;">
	<div class="classStyle">
		欢迎进入分销系统！
	</div>
<!--	<h1 class="page-header" style="text-align:left">首页 <small></small></h1>-->
<!--     	<div class="row">-->
<!--				&lt;!&ndash; begin col-3 &ndash;&gt;-->
<!--				<div class="col-lg-3 col-md-6">-->
<!--					<div class="widget widget-stats bg-blue">-->
<!--						<div class="stats-icon"><i class="icon-handbag"></i></div>-->
<!--						<div class="stats-info">-->
<!--							<h4>本月订单数量</h4>-->
<!--							<p>1500</p>	-->
<!--						</div>-->
<!--						<div class="stats-link">-->
<!--							<a href="javascript:;">更多 <i class="fa fa-arrow-alt-circle-right"></i></a>-->
<!--						</div>-->
<!--					</div>-->
<!--				</div>-->
<!--				&lt;!&ndash; end col-3 &ndash;&gt;-->
<!--				&lt;!&ndash; begin col-3 &ndash;&gt;-->
<!--				<div class="col-lg-3 col-md-6">-->
<!--					<div class="widget widget-stats bg-green">-->
<!--						<div class="stats-icon"><i class="icon-wallet"></i></div>-->
<!--						<div class="stats-info">-->
<!--							<h4>本月销售金额</h4>-->
<!--							<p>888888</p>	-->
<!--						</div>-->
<!--						<div class="stats-link">-->
<!--							<a href="javascript:;">更多 <i class="fa fa-arrow-alt-circle-right"></i></a>-->
<!--						</div>-->
<!--					</div>-->
<!--				</div>-->
<!--				&lt;!&ndash; end col-3 &ndash;&gt;-->
<!--				&lt;!&ndash; begin col-3 &ndash;&gt;-->
<!--			-->
<!--				&lt;!&ndash; end col-3 &ndash;&gt;-->
<!--				&lt;!&ndash; begin col-3 &ndash;&gt;-->
<!--				<div class="col-lg-3 col-md-6">-->
<!--					<div class="widget widget-stats bg-red">-->
<!--						<div class="stats-icon"><i class="icon-bell"></i></div>-->
<!--						<div class="stats-info">-->
<!--							<h4>异常订单</h4>-->
<!--							<p>3</p>	-->
<!--						</div>-->
<!--						<div class="stats-link">-->
<!--							<a href="javascript:;">更多 <i class="fa fa-arrow-alt-circle-right"></i></a>-->
<!--						</div>-->
<!--					</div>-->
<!--				</div>-->
<!--				&lt;!&ndash; end col-3 &ndash;&gt;-->
<!--				<div class="col-lg-3 col-md-6">-->
<!--					<div class="widget widget-stats bg-orange">-->
<!--						<div class="stats-icon"><i class="icon-user"></i></div>-->
<!--						<div class="stats-info">-->
<!--							<h4>售后</h4>-->
<!--							<p>2</p>	-->
<!--						</div>-->
<!--						<div class="stats-link">-->
<!--							<a href="javascript:;">更多 <i class="fa fa-arrow-alt-circle-right"></i></a>-->
<!--						</div>-->
<!--					</div>-->
<!--				</div>-->
<!--			</div>-->
			<!-- begin #page-loader -->
<!--	<div id="page-loader" class="fade"><span class="spinner"></span></div>-->
	<!-- end #page-loader -->
	
	<!-- begin #page-container -->
<!--	<div id="page-container" class="in page-sidebar-fixed page-header-fixed" style="padding-top:0px;">-->
<!--		-->
<!--		&lt;!&ndash; begin #content &ndash;&gt;-->
<!--		<div id="content" class="content" style="margin-left:0px;padding-left:0px;padding-right:0px;padding-top:0px">-->
<!--			&lt;!&ndash; begin breadcrumb &ndash;&gt;-->
<!--		-->
<!--			-->
<!--			<div class="row">-->
<!--		-->
<!--				&lt;!&ndash; begin col-10 &ndash;&gt;-->
<!--				<div class="col-lg-12">-->
<!--					<div class="panel panel-inverse" data-sortable-id="flot-chart-2">-->
<!--						<div class="panel-heading">-->
<!--							<div class="panel-heading-btn">-->
<!--								<a href="javascript:;" class="btn btn-xs btn-icon btn-circle btn-default" data-click="panel-expand"><i class="fa fa-expand"></i></a>-->
<!--								<a href="javascript:;" class="btn btn-xs btn-icon btn-circle btn-success" data-click="panel-reload"><i class="fa fa-redo"></i></a>-->
<!--								<a href="javascript:;" class="btn btn-xs btn-icon btn-circle btn-warning" data-click="panel-collapse"><i class="fa fa-minus"></i></a>-->
<!--								<a href="javascript:;" class="btn btn-xs btn-icon btn-circle btn-danger" data-click="panel-remove"><i class="fa fa-times"></i></a>-->
<!--							</div>-->
<!--							<h4 class="panel-title">订单每月趋势</h4>-->
<!--						</div>-->
<!--						<div class="panel-body">-->
<!--							<div id="interactive-chart" class="height-sm"></div>-->
<!--						</div>-->
<!--					</div>-->
<!--					&lt;!&ndash; end panel &ndash;&gt;-->
<!--				</div>-->
<!--				&lt;!&ndash; end col-10 &ndash;&gt;-->
<!--				<div class="col-lg-12">-->
<!--           	<div class="panel panel-inverse" data-sortable-id="flot-chart-6">-->
<!--						<div class="panel-heading">-->
<!--							<div class="panel-heading-btn">-->
<!--								<a href="javascript:;" class="btn btn-xs btn-icon btn-circle btn-default" data-click="panel-expand"><i class="fa fa-expand"></i></a>-->
<!--								<a href="javascript:;" class="btn btn-xs btn-icon btn-circle btn-success" data-click="panel-reload"><i class="fa fa-redo"></i></a>-->
<!--								<a href="javascript:;" class="btn btn-xs btn-icon btn-circle btn-warning" data-click="panel-collapse"><i class="fa fa-minus"></i></a>-->
<!--								<a href="javascript:;" class="btn btn-xs btn-icon btn-circle btn-danger" data-click="panel-remove"><i class="fa fa-times"></i></a>-->
<!--							</div>-->
<!--							<h4 class="panel-title">库存柱状图</h4>-->
<!--						</div>-->
<!--						<div class="panel-body">-->
<!--							<div id="stacked-chart" class="height-sm"></div>-->
<!--						</div>-->
<!--					</div>-->
<!--         -->
<!--				</div>-->
<!--			</div>-->
<!--			&lt;!&ndash; end row &ndash;&gt;-->
<!--		</div>-->
<!--		&lt;!&ndash; end #content &ndash;&gt;-->
<!--	-->
<!--	</div>-->
	
</div>		
</template>

<script>
export default {
  name: 'Index',
  data () {
    return {
    
    }
  },
   mounted: function() {
			this.initdate();
    
 },
 methods:{
	initdate() {
      for(var s = [], h = 0; h <= 5; h += 1) s.push([h, parseInt(5 * Math.random() + 5)]);
		for(var d = [], c = 0; c <= 5; c += 1) d.push([c, parseInt(5 * Math.random() + 5)]);
		var R = [{
			data: s,
			color: COLOR_BLUE,
			label: "USA",
			bars: {
				fillColor: COLOR_BLUE
			}
		}, {
			data: d,
			color: COLOR_AQUA,
			label: "Others",
			bars: {
				fillColor: COLOR_AQUA
			}
		}];
		$.plot("#stacked-chart", R, {
			xaxis: {
				tickColor: COLOR_GREY_LIGHTER,
				ticks: [
					[0, "周一"],
					[1, "周二"],
					[2, "周三"],
					[3, "周四"],
					[4, "周五"],
					[5, "周六"]
				],
				autoscaleMargin: .05
			},
			yaxis: {
				tickColor: COLOR_GREY_LIGHTER,
				ticksLength: 5
			},
			grid: {
				hoverable: !0,
				tickColor: COLOR_GREY_LIGHTER,
				borderWidth: 1,
				borderColor: COLOR_GREY_LIGHTER,
				backgroundColor: COLOR_SILVER_LIGHTER
			},
			series: {
				stack: !0,
				lines: {
					show: !1,
					fill: !1,
					steps: !1
				},
				bars: {
					show: !0,
					barWidth: .6,
					align: "center",
					fillColor: null
				},
				highlightColor: COLOR_BLACK_TRANSPARENT_9
			},
			legend: {
				show: !0,
				position: "ne",
				noColumns: 1
			}
		});

      if (0 !== $("#interactive-chart").length) {
        var a = [
          [1, 42],
          [2, 53],
          [3, 66],
          [4, 60],
          [5, 68],
          [8, 66],
          [9, 71],
          [10, 75],
          [11, 69],
          [12, 70],
          [15, 68],
          [16, 72],
          [17, 78],
          [18, 86],
          [19, 76],
          [22, 75],
          [23, 69],
          [24, 70],
          [25, 68],
          [26, 72]
        ];
        $.plot(
          $("#interactive-chart"),
          [
            {
              data: a,
              label: "订单数量",
              color: COLOR_BLUE,
              lines: {
                show: !0,
                fill: !1,
                lineWidth: 2.5
              },
              points: {
                show: !0,
                radius: 5,
                fillColor: COLOR_WHITE
              },
              shadowSize: 0
            }
          ],
          {
            xaxis: {
              tickColor: COLOR_GREY_LIGHTER,
              tickSize: 2
            },
            yaxis: {
              tickColor: COLOR_GREY_LIGHTER,
              tickSize: 20
            },
            grid: {
              hoverable: !0,
              clickable: !0,
              tickColor: COLOR_BLACK_TRANSPARENT_3,
              borderWidth: 1,
              borderColor: COLOR_BLACK_TRANSPARENT_2,
              backgroundColor: COLOR_SILVER_LIGHTER
            },
            legend: {
              noColumns: 1,
              show: !0
            }
          }
        );
        var o = null;
        $("#interactive-chart").bind("plothover", function(a, t, r) {
          if (($("#x").text(t.x.toFixed(2)), $("#y").text(t.y.toFixed(2)), r)) {
            if (o !== r.dataIndex) {
              (o = r.dataIndex), $("#tooltip").remove();
              var e = r.datapoint[1].toFixed(2),
                l = r.series.label + " " + e;
              $('<div id="tooltip" class="flot-tooltip">' + l + "</div>")
                .css({
                  top: r.pageY,
                  left: r.pageX + 35
                })
                .appendTo("body")
                .fadeIn(200);
            }
          } else $("#tooltip").remove(), (o = null);
          a.preventDefault();
        });
      }
    }
 }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.classStyle {
		font-size: 30px;
		margin-top: 50px;
	}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue